'use client';

import React from 'react';

import { Anchor, Box, Button, Stack, Text } from '@mantine/core';

import { Block } from '@marketing/components/blocks/Block';
import { TextBlock } from '@marketing/components/blocks/TextBlock';
import { PageHeader } from '@marketing/components/page-header/PageHeader';
import { Section } from '@marketing/components/section/Section';
import { SectionHeader } from '@marketing/components/section/SectionHeader';
import { SectionSpacer } from '@marketing/components/section/SectionSpacer';

import { ReplusLogo } from 'components/logo/ReplusLogo';

const CreateAccountPage = () => {
    return (
        <>
            <PageHeader
                color="white"
                bg="purple"
                variant="dark"
                title={
                    <>
                        <ReplusLogo c="white" w={120} />
                        <br /> Create User Account
                    </>
                }
                description="Maximize your RE+Source PRO experience"
            />

            <Section>
                <SectionHeader
                    title="Why Create a User Account?"
                    description="To maximize your RE+Source PRO experience, please create a user account."
                />

                <SectionSpacer size="sm" />

                <Block size="md">
                    <TextBlock>
                        <Box>Once this has been completed, you can:</Box>
                        <Box component="ul" style={{ paddingLeft: '1.5rem' }}>
                            <li>
                                <strong>Bookmark companies, products, and services</strong> you are interested in
                                returning to view.
                            </li>
                            <li>
                                <strong>Bookmark case studies</strong> you found of interest.
                            </li>
                            <li>
                                <strong>Save microgrid designs</strong> created using the DCIDE tool.
                            </li>
                            <li>
                                <strong>Access exclusive content</strong> and stay updated with the latest industry
                                insights.
                            </li>
                            <li>
                                <strong>Connect with industry professionals</strong> and expand your network.
                            </li>
                        </Box>
                    </TextBlock>
                </Block>
            </Section>

            <Section variant="light">
                <SectionHeader title="Ready to unlock all these features?" />

                <SectionSpacer size="sm" />

                <Block size="sm">
                    <Stack align="center" gap="lg">
                        <Button size="lg" component="a" href="/login?redirect=/resourcepro">
                            Create Your Account
                        </Button>

                        <Text c="dimmed" ta="center">
                            Already have an account?{' '}
                            <Anchor href="/login?redirect=/resourcepro" inherit fw={500}>
                                Sign in
                            </Anchor>
                        </Text>
                    </Stack>
                </Block>
            </Section>
        </>
    );
};

export default CreateAccountPage;
